import { html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { BaseElement } from "../BaseElement";
import { LightTheme } from "../ThemeLight";

import { styles } from "./UserProfileAbout.style";
import { IUserInfo } from "../../backend/cloud/UserTable";
import { litIf } from "../LitUtils";

@customElement("ds-user-profile-about")
export class UserProfileAbout extends BaseElement {
    static override styles = [styles, LightTheme];
    @property({ type: Object }) userInfo?: IUserInfo;

    override render() {
        return html`<div class="flex-column">
            ${litIf(
                this.userInfo,
                () =>
                    html`${litIf(
                            this.userInfo!.bio && this.userInfo!.bio.length > 0,
                            () => html`<span>${this.userInfo?.bio}</span>`
                        )}
                        <ds-social-links
                            .socials=${this.userInfo?.socials ?? undefined}
                            direction="column"
                        ></ds-social-links>`
            )}
        </div>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "ds-user-profile-about": UserProfileAbout;
    }
}
